import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../../../styles/dashboardTheme.css";
import "../../../../styles/managementTheme.css";
import "../styles/niveles.css";
import NivelesSummary from "../components/NivelesSummary";
import NivelesTable from "../components/NivelesTable";
import NivelesFormModal from "../components/NivelesFormModal";
import CoordinacionTabs from "../../catalogo/components/CoordinacionTabs";
import { usePermissions } from "../../../../utils/permissions";

export default function NivelesView({
  niveles,
  filtro,
  aplicarFiltro,
  resumen,
  loading,
  error,
  lastUpdated,
  reload,
  dismissError,
  modal,
  formNuevo,
  setFormNuevo,
  formEditar,
  setFormEditar,
  savingNuevo,
  savingEditar,
  deleting,
  nivelSeleccionado,
  abrirModalNuevo,
  abrirModalEditar,
  abrirModalEliminar,
  cerrarModal,
  handleCrearNivel,
  handleActualizarNivel,
  handleEliminarNivel,
}) {
  const { hasPermission } = usePermissions();
  const canCreateNivel = hasPermission("niveles.crear");
  const canUpdateNivel = hasPermission("niveles.actualizar");
  const canDeleteNivel = hasPermission("niveles.eliminar");

  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    if (modal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [modal]);

  const lastSync = lastUpdated ? lastUpdated.toLocaleString() : "Sincronizacion inicial";

  return (
    <section className="management-page management-theme-blue niveles-wrapper">
      <CoordinacionTabs />
      <div className="management-card management-header mb-4">
        <div>
          <p className="management-eyebrow mb-1">Academico</p>
          <h4 className="management-title mb-1">Niveles Academicos</h4>
          <p className="text-muted mb-0">
            Gestiona los niveles de formacion registrados en la plataforma.
          </p>
        </div>
        <div className="d-flex flex-column align-items-end gap-2">
          {canCreateNivel && (
            <button type="button" className="btn management-btn-primary" onClick={abrirModalNuevo}>
              <i className="bi bi-plus-circle me-2" />
              Nuevo Nivel
            </button>
          )}
          <small className="text-muted">Actualizado: {lastSync}</small>
        </div>
      </div>

      <NivelesSummary resumen={resumen} onQuickFilter={aplicarFiltro} activeKey={filtro} />

      {error && (
        <div className="management-alert d-flex align-items-center justify-content-between gap-3 flex-wrap">
          <span>{error}</span>
          <div className="d-flex gap-2 flex-wrap">
            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={dismissError}>
              Cerrar
            </button>
            <button type="button" className="btn btn-sm btn-primary" onClick={reload}>
              Reintentar
            </button>
          </div>
        </div>
      )}

      <NivelesTable
        niveles={niveles}
        loading={loading}
        reload={reload}
        onEdit={canUpdateNivel ? abrirModalEditar : undefined}
        onDelete={canDeleteNivel ? abrirModalEliminar : undefined}
        canEdit={canUpdateNivel}
        canDelete={canDeleteNivel}
      />

      <NivelesFormModal
        modal={modal}
        formNuevo={formNuevo}
        setFormNuevo={setFormNuevo}
        formEditar={formEditar}
        setFormEditar={setFormEditar}
        savingNuevo={savingNuevo}
        savingEditar={savingEditar}
        deleting={deleting}
        nivelSeleccionado={nivelSeleccionado}
        cerrarModal={cerrarModal}
        handleCrearNivel={handleCrearNivel}
        handleActualizarNivel={handleActualizarNivel}
        handleEliminarNivel={handleEliminarNivel}
        canUpdate={canUpdateNivel}
        canDelete={canDeleteNivel}
      />
    </section>
  );
}
